// import React, { useState, useRef, useEffect } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import Backdrop from "../Backgrounds/Backdrop";

// const DropdownMenu = ({
//   children,
//   MenuSection,
//   position = "bottom",
//   menuWidth,
//   menuAlign = "left",
//   minWidth = "180px",
//   maxWidth,
//   responsiveWidth = true, // New prop for responsive behavior
// }) => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [dynamicPosition, setDynamicPosition] = useState(position);
//   const [menuStyle, setMenuStyle] = useState({});
//   const dropdownRef = useRef(null);
//   const menuRef = useRef(null);

//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setIsOpen(false);
//       }
//     };

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   useEffect(() => {
//     if (isOpen && menuRef.current && dropdownRef.current) {
//       requestAnimationFrame(() => {
//         const trigger = dropdownRef.current;
//         const menu = menuRef.current;
//         const triggerRect = trigger.getBoundingClientRect();
//         const menuWidth = menu.offsetWidth;

//         let style = {
//           position: "fixed",
//           top: triggerRect.bottom + 8,
//         };

//         // Handle responsive width
//         if (responsiveWidth) {
//           if (window.innerWidth <= 640) {
//             style.width = "95vw";
//             style.maxWidth = window.innerWidth - 20;
//           } else {
//             style.width = menuWidth || "auto";
//             style.minWidth = minWidth;
//             style.maxWidth = maxWidth || `${window.innerWidth - 40}px`;
//           }
//         } else {
//           style.width = menuWidth;
//           style.minWidth = minWidth;
//           style.maxWidth = maxWidth;
//         }

//         // Calculate left position based on alignment
//         switch (menuAlign) {
//           case "right":
//             style.left = triggerRect.right - (style.width || menu.offsetWidth);
//             break;
//           case "center":
//             style.left =
//               triggerRect.left +
//               triggerRect.width / 2 -
//               (style.width || menu.offsetWidth) / 2;
//             break;
//           default: // "left"
//             style.left = triggerRect.left;
//         }

//         // Ensure menu stays within viewport
//         const viewportWidth = window.innerWidth;
//         if (style.left < 10) style.left = 88;
//         if (
//           style.left + (style.width || menu.offsetWidth) >
//           viewportWidth - 10
//         ) {
//           style.left = viewportWidth - (style.width || menu.offsetWidth) - 10;
//         }

//         setMenuStyle(style);
//       });
//     }
//   }, [isOpen, menuWidth, menuAlign, minWidth, maxWidth, responsiveWidth]);

//   // const handleMenuClick = (event) => {
//   //   if (event.target.closest('button, a, [role="button"]')) {
//   //     setIsOpen(false);
//   //   }
//   // };

//   const handleMenuClick = (event) => {
//     // Using a more specific attribute name
//     const keepOpenElement = event.target.closest(
//       '[data-dropdown-persist="true"]'
//     );
//     if (
//       !keepOpenElement &&
//       event.target.closest('button, a, [role="button"]')
//     ) {
//       setIsOpen(false);
//     }
//   };

//   const positionStyles = {
//     bottom: "top-full mt-1",
//     top: "bottom-full mb-1",
//     left: "right-full mr-1 -translate-x-full", // Added transform for left positioning
//     right: "left-full ml-1",
//   };

//   return (
//     <div className="relative inline-block" ref={dropdownRef}>
//       <div onClick={() => setIsOpen(!isOpen)}>
//         {React.cloneElement(children, {
//           // active: isOpen,
//           // noTooltip: isOpen,
//         })}
//       </div>

//       <AnimatePresence>
//         {isOpen && (
//           <motion.div
//             ref={menuRef}
//             initial={{
//               opacity: 0,
//               x: position === "left" ? -10 : 0,
//               y: position !== "left" ? -10 : 0,
//             }}
//             animate={{ opacity: 1, x: 0, y: 0 }}
//             exit={{
//               opacity: 0,
//               x: position === "left" ? -10 : 0,
//               y: position !== "left" ? -10 : 0,
//             }}
//             transition={{ duration: 0.2 }}
//             className={`fixed z-50 py-1 bg-white shadow-xl border border-gray-200 rounded-md`}
//             style={menuStyle}
//             onClick={handleMenuClick}
//           >
//             {MenuSection}
//           </motion.div>
//         )}
//       </AnimatePresence>
//     </div>
//   );
// };

// export default DropdownMenu;
import React, { useState, useRef, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const DropdownMenu = ({
  children,
  MenuSection,
  position = "bottom",
  menuWidth,
  menuAlign = "left",
  minWidth = "180px",
  maxWidth,
  responsiveWidth = true, // New prop for responsive behavior
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [dynamicPosition, setDynamicPosition] = useState(position);
  const [menuStyle, setMenuStyle] = useState({});
  const dropdownRef = useRef(null);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (!isOpen || !menuRef.current || !dropdownRef.current) return;

    requestAnimationFrame(() => {
      const trigger = dropdownRef.current;
      const menu = menuRef.current;

      const triggerRect = trigger.getBoundingClientRect();
      const menuHeight = menu.offsetHeight;
      const menuActualWidth = menu.offsetWidth;

      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;

      const spaceBelow = viewportHeight - triggerRect.bottom;
      const spaceAbove = triggerRect.top;

      let finalPosition = position;

      // Auto flip top/bottom
      if (
        position === "bottom" &&
        spaceBelow < menuHeight + 10 &&
        spaceAbove > menuHeight + 10
      ) {
        finalPosition = "top";
      }

      setDynamicPosition(finalPosition);

      let style = {
        position: "fixed",
      };

      // Vertical position
      if (finalPosition === "top") {
        style.bottom = viewportHeight - triggerRect.top + 8;
      } else {
        style.top = triggerRect.bottom + 8;
      }

      // Width handling
      if (responsiveWidth) {
        if (viewportWidth <= 640) {
          style.width = "95vw";
          style.maxWidth = viewportWidth - 20;
        } else {
          style.width = menuWidth || "auto";
          style.minWidth = minWidth;
          style.maxWidth = maxWidth || viewportWidth - 40;
        }
      } else {
        style.width = menuWidth;
        style.minWidth = minWidth;
        style.maxWidth = maxWidth;
      }

      const resolvedWidth =
        typeof style.width === "number" ? style.width : menuActualWidth;

      // Horizontal alignment
      switch (menuAlign) {
        case "right":
          style.left = triggerRect.right - resolvedWidth;
          break;
        case "center":
          style.left =
            triggerRect.left + triggerRect.width / 2 - resolvedWidth / 2;
          break;
        default:
          style.left = triggerRect.left;
      }

      // Keep inside viewport
      if (style.left < 10) style.left = 10;
      if (style.left + resolvedWidth > viewportWidth - 10) {
        style.left = viewportWidth - resolvedWidth - 10;
      }

      // Safety: scroll if tight space
      const maxAvailableHeight = Math.max(spaceAbove, spaceBelow) - 16;
      if (menuHeight > maxAvailableHeight) {
        style.maxHeight = maxAvailableHeight;
        style.overflowY = "auto";
      }

      setMenuStyle(style);
    });
  }, [
    isOpen,
    position,
    menuWidth,
    menuAlign,
    minWidth,
    maxWidth,
    responsiveWidth,
  ]);

  // Close on item click (unless persisted)
  const handleMenuClick = (e) => {
    const persist = e.target.closest('[data-dropdown-persist="true"]');
    if (!persist && e.target.closest("button, a, [role='button']")) {
      setIsOpen(false);
    }
  };

  return (
    <div className="relative inline-block" ref={dropdownRef}>
      <div onClick={() => setIsOpen(!isOpen)}>
        {React.cloneElement(children, {
          // active: isOpen,
          // noTooltip: isOpen,
        })}
      </div>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            ref={menuRef}
            initial={{
              opacity: 0,
              y: dynamicPosition === "top" ? 10 : -10,
            }}
            animate={{ opacity: 1, y: 0 }}
            exit={{
              opacity: 0,
              y: dynamicPosition === "top" ? 10 : -10,
            }}
            transition={{ duration: 0.2 }}
            className="fixed z-50 py-1 bg-white shadow-xl border border-gray-200 rounded-md"
            style={menuStyle}
            onClick={handleMenuClick}
          >
            {MenuSection}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default DropdownMenu;
